import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import Modal from "react-bootstrap/Modal";
import { AddImageIcon, CancelIcon, CloseIcon } from "../assets/Icons";
import apiClient from "../apiClient";
import {
  ASSIGN_APPLICATION_TO_CHANNEL,
  GET_ALL_APPLICATION,
  UPLOAD_APPLICATION_LOGO,
} from "../apiClient/apiEndpoints";
import { SSO_URL } from "../env";
import { UnoStoreHooks } from "@simulanisindia/ui";
import axios from "axios";
import { debounce } from "../components/common/Debounce";
const { useUnoSelector } = UnoStoreHooks;
const defaultValues = {
  application: null,
  channel: null,
  name: "",
  banner: "",
  logo: "",
};
const errorDefaultValues = {
  application: { active: false, message: "Please Select Application" },
  channel: { active: false, message: "Please select Channel" },
  name: { active: false, message: "Please Add Application Name" },
  banner: { active: false, message: "Please Add Banner" },
  logo: { active: false, message: "Please Add Logo" },
};

const checkError = (payload) => {
  let hasError = false;
  const newErrors = JSON.parse(JSON.stringify(errorDefaultValues));
  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    const isInvalid = !value;
    newErrors[key] = {
      ...errorDefaultValues[key],
      active: isInvalid,
    };
    if (isInvalid) hasError = true;
  });

  return { hasError, newErrors };
};

const AddDirectoryApplication = ({
  openApplicationModal,
  setOpenApplicationModal,
  channelData = [],
  selectChannelDisable = false,
  assignedApplications = [],
  getChannelApplications = () => {},
}) => {
  const [channelList, setChannelList] = useState([]);
  const userData = useUnoSelector((state) => state.user);
  const [appList, setAppList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);
  const [responseError, setResponseError] = useState("");
  const [error, seterror] = useState(errorDefaultValues);

  const handleDrop = (field) => async (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("randomize", true);
    const uploadedImageData = await handleImageUpload(formData, field);
    setFormValues((prev) => ({ ...prev, [field]: uploadedImageData?.url }));
  };

  const { getRootProps: getLogoRootProps, getInputProps: getLogoInputProps } = useDropzone({
    onDrop: handleDrop("logo"),
    accept: "image/*",
    multiple: false,
  });

  const { getRootProps: getBannerRootProps, getInputProps: getBannerInputProps } = useDropzone({
    onDrop: handleDrop("banner"),
    accept: "image/*",
    multiple: false,
  });

  const fetchAppList = async () => {
    try {
      const data = await apiClient.get(`${SSO_URL}${GET_ALL_APPLICATION}`);
      const previouseApplications = assignedApplications?.map((e) => e.uuid);
      const appOptions = data
        ?.filter((e) => !previouseApplications.includes(e.uuid))
        .map((item) => ({ label: item.name, value: item.uuid }));
      setAppList(appOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageUpload = async (payload, type) => {
    try {
      const res = await axios.post(`${SSO_URL}${UPLOAD_APPLICATION_LOGO}/${type}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userData.token}`,
        },
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleImageCancelClick = (e, key) => {
    e.stopPropagation();
    setFormValues((prev) => ({ ...prev, [key]: "" }));
  };

  const closeModal = () => {
    setFormValues(defaultValues);
    seterror(errorDefaultValues);
    setOpenApplicationModal(false);
  };

  const handleSave = async () => {
    const { hasError, newErrors } = checkError(formValues);
    if (hasError) {
      seterror(newErrors);
      return;
    }
    try {
      setLoading(true);
      setResponseError("");
      const payload = {
        name: formValues.name,
        banner: formValues.banner,
        logo: formValues.logo,
        applicationId: formValues.application.value,
      };
      await apiClient.post(`${SSO_URL}${ASSIGN_APPLICATION_TO_CHANNEL}/${formValues.channel.value}`, payload);
      getChannelApplications();
      closeModal();
    } catch (error) {
      setResponseError(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const debounceSave = debounce(handleSave, 500);

  useEffect(() => {
    if (channelData.length) {
      let _channelList = channelData.map((item) => ({ label: item.name, value: item.uuid }));
      setChannelList(_channelList);
      if (selectChannelDisable && _channelList.length === 1) {
        setFormValues((prev) => ({ ...prev, channel: _channelList[0] }));
      }
    }
  }, [channelData.length, openApplicationModal]);

  useEffect(() => {
    fetchAppList();
  }, [openApplicationModal]);

  return (
    <Modal show={openApplicationModal} size="md" centered onHide={closeModal}>
      <Modal.Header className="modalheader">
        Add Application
        <span onClick={closeModal}>
          <CloseIcon />
        </span>
      </Modal.Header>

      <Modal.Body className="pb-0">
        <div className="row">
          <div className="image-formbox mt-0">
            <div {...getLogoRootProps()} className="dropbox">
              <input {...getLogoInputProps()} />
              {formValues.logo ? (
                <div className="uploaded-container">
                  <img src={formValues.logo} alt="Uploaded" className="uploaded-image" />
                  <button onClick={(e) => handleImageCancelClick(e, "logo")} className="cancel-button">
                    <CancelIcon />
                  </button>
                </div>
              ) : (
                <div className="placeholder">
                  <AddImageIcon />
                </div>
              )}
            </div>

            <div className="d-flex align-items-start flex-column justify-content-start">
              <p>Logo</p>
              <p className="little-info">Recommended Format* PNG</p>
              <p className="error">{error.logo.active && error.logo.message}</p>
            </div>
          </div>

          <div className="image-formbox mt-4">
            <div {...getBannerRootProps()} className="dropbox">
              <input {...getBannerInputProps()} />
              {formValues.banner ? (
                <div className="uploaded-container">
                  <img src={formValues.banner} alt="Uploaded" className="uploaded-image" />
                  <button onClick={(e) => handleImageCancelClick(e, "banner")} className="cancel-button">
                    <CancelIcon />
                  </button>
                </div>
              ) : (
                <div className="placeholder">
                  <AddImageIcon />
                </div>
              )}
            </div>
            <div className="d-flex align-items-start flex-column justify-content-start">
              <p>Banner</p>
              <p className="little-info">Recommended Format* PNG</p>
              <p className="error">{error.banner.active && error.banner.message}</p>
            </div>
          </div>

          <div className="col-12 standardinput mt-4">
            <label className="mb-2">
              Configuration Name <span>*</span>
            </label>
            <input
              autoComplete="off"
              name="name"
              id="name"
              className="input form-control"
              type="text"
              value={formValues.name}
              onChange={(e) => handleFormChange("name", e.target.value)}
            />
            <p className="error">{error.name.active && error.name.message}</p>
          </div>

          <div className="col-12 standardinput mt-3">
            <label className="mb-2">
              Select Channel <span>*</span>
            </label>
            <div className="forselect-input">
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  colors: {
                    ...theme.colors,
                    primary50: "#ca373c50",
                    primary25: "#ca373c50",
                    primary: "#ca373c70",
                    danger: "#000000",
                    neutral30: "#00000050",
                  },
                })}
                options={channelList}
                onChange={(value) => handleFormChange("channel", value)}
                value={formValues.channel}
                isDisabled={selectChannelDisable}
              />
              <p className="error">{error.channel.active && error.channel.message}</p>
            </div>
          </div>
          <div className="col-12 standardinput mt-3 ">
            <label className="mb-2">
              Select Application <span>*</span>
            </label>
            <div className="forselect-input">
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  colors: {
                    ...theme.colors,
                    primary50: "#ca373c50",
                    primary25: "#ca373c50",
                    primary: "#ca373c70",
                    danger: "#000000",
                    neutral30: "#00000050",
                  },
                })}
                options={appList}
                onChange={(value) => handleFormChange("application", value)}
                value={formValues.application}
              />
              <p className="error">{error.application.active && error.application.message}</p>
            </div>
          </div>
          <div className="col-12 standardinput mt-3 ">
            <p className="error">{responseError}</p>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="footerbtn mt-3">
        <button className="cancel" onClick={closeModal}>
          Cancel
        </button>
        {!loading ? (
          <button className="save" onClick={debounceSave}>
            Save
          </button>
        ) : (
          <button className="loading save">
            <svg viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AddDirectoryApplication;
